export enum Direction {
  LEFT = "LEFT",
  TOP_LEFT = "TOP_LEFT",
  BOTTOM_LEFT = "BOTTOM_LEFT",
  RIGHT = "RIGHT",
  TOP_RIGHT = "TOP_RIGHT",
  BOTTOM_RIGHT = "BOTTOM_RIGHT",
  TOP = "TOP",
  BOTTOM = "BOTTOM",
}

export const Directions: Direction[] = [
  Direction.LEFT,
  Direction.TOP_LEFT,
  Direction.BOTTOM_LEFT,
  Direction.RIGHT,
  Direction.TOP_RIGHT,
  Direction.BOTTOM_RIGHT,
  Direction.TOP,
  Direction.BOTTOM,
];

export const POSTBOX_TEMPLATES = ["the_base_postbox"];

export const FLOOR_INFO_TEMPLATES = ["the_base_floorinfo"];

export const THE_BASE_LETTERS = ["A", "B", "C", "D"];

export const MESSAGE_TEMPLATES = [
  "FoodDeliveryArrived",
  "PackageDeliveryArrived",
  "EmployeeVisitorArrived",
];

export const CUSTOMIZABLE_LAYOUT_RECEPTIONS = ["digitalreception"];
export const CUSTOMIZABLE_ANIMATIONS_RECEPTIONS = ["digitalreception"];

export const CUSTOMIZABLE_THEME_RECEPTIONS = [
  "digitalreception",
  "hydro",
  "spectro",
];
export const CUSTOMIZABLE_THEME_COLORS_RECEPTIONS = [
  "digitalreception",
  "hydro",
];
export const CUSTOMIZABLE_THEME_LOGO_RECEPTIONS = ["digitalreception", "hydro"];

export const CUSTOMIZABLE_THEME_VIDEO_RECEPTIONS = ["spectro"];

// Receptions whose SPA can render a set of questions after check-in. The rest of the stack is
// generic, so adding a template here is all it takes once its bundle has the page.
export const POST_CHECKIN_FORM_RECEPTIONS = ["spectro"];

export type GeneralSettingsSection =
  | "teamsVideoCall"
  | "receptionistPhone"
  | "receptionistTeams"
  | "deliveryReceiver"
  | "bell"
  | "animations"
  | "overview"
  | "printing"
  | "contactPreview"
  | "postCheckinForm"
  | "call"
  | "wifi"
  | "accessControl"
  | "support"
  | "scanner"
  | "nfc"
  | "dispenser"
  | "photoCapture";

export const GENERAL_SETTINGS_SECTIONS_BY_RECEPTION: Record<
  string,
  GeneralSettingsSection[]
> = {
  ambulance_oost: ["receptionistPhone"],
  bouwmensen: ["receptionistPhone"],
  eriks_nv: ["receptionistPhone"],
  flexcom: ["receptionistPhone"],
  hapag_lloyd: [],
  horapark: ["receptionistPhone"],
  hydro: ["receptionistPhone"],
  jungheinrich: ["receptionistPhone", "overview"],
  kyocera: ["receptionistPhone"],
  luxor_theatre: [],
  mathot: ["receptionistPhone"],
  mmmr: ["receptionistPhone"],
  pando: ["receptionistPhone"],
  ppf: ["receptionistPhone", "deliveryReceiver"],
  roc_glide: ["receptionistPhone", "overview", "printing"],
  spectro: ["receptionistPhone", "postCheckinForm"],
  // Its delivery receiver comes from metadata, not from this page.
  spie: ["receptionistPhone"],
  swartberg: ["receptionistPhone"],
  // Delivery receiver from metadata here too; support e-mail and dispenser from this page.
  te_connectivity: ["receptionistPhone", "support", "dispenser"],
  tihub: [],
  // useDeliveryReceiver exists there, but only commented-out code calls it.
  woonzorg_flevoland: ["receptionistPhone"],
  wupperman: ["receptionistPhone", "deliveryReceiver"],
};

export const MULTITENANT_CLIENTS = ["default-client"];

export const NEDAP_CLIENTS = [
  "woonzorg", // dev
  "woonzorg-flevoland", // prod
];

export enum UserRolesPriority {
  ADMIN = 0,
  CLIENT_ADMIN = 1,
  CLIENT = 2,
  TORO1 = 1, // @todo Check this priority with Aca or Pedja
  ACTIVITY = 4,
  PICK_UP = 4,
  SERVICE_EMPLOYEE = 4,
  ACTIVITY_CHECKED_IN = 5,
}
